module.exports = __webpack_public_path__ + "static/img/skaggs.92eb71c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/cards/northern/skaggs.png
// module id = Wt2M
// module chunks = 0